export default __webpack_public_path__ + "static/media/dash-preview.8b940ed0.png";